import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row } from "react-bootstrap";
import { setSelectedCrews, saveUserConfiguration, getUserConfiguration } from "../../../actions/dashboard";

const CrewFilteredList = () => {
  const dispatch = useDispatch();
  const crewListById = useSelector((state) => state.dashboard.crew.crewListById.filteredPayload);
  const selectedCrewIds = useSelector((state) => state.dashboard.crew.selectedCrewIds);
  const selectedPlanTypeIds = useSelector((state) => state.dashboard.crew.selectedPlanTypeIds);
  const farmId = useSelector((state) => state.farm.currentFarm.farm_uuid);
  const selectedPlanType = useSelector((state) => state.plan.selectedPlanType);
  const userRemember = useSelector((state) => state.dashboard.userRemember.payload);
  const crewList = Object.keys(crewListById).map((id) => crewListById[id]);

  let filteredCrewInfo = [];
  selectedCrewIds.forEach((id) => {
    if (crewListById[id]) filteredCrewInfo.push(crewListById[id]);
  });
  filteredCrewInfo = filteredCrewInfo.filter((e) => selectedPlanTypeIds.length === 0 || selectedPlanTypeIds.indexOf(e.plan_type_id) >= 0);

  const plantedCrewIds = useMemo(() => {
    return crewList.filter((each) => each.plan_type_id === selectedPlanType).map((e) => e.crew_uuid);
  }, [crewList]);

  const handleCloseButton = (id) => {
    selectedCrewIds.splice(selectedCrewIds.indexOf(id), 1);
    const finalSelectedCrewList = selectedCrewIds
      .filter((e) => plantedCrewIds.includes(e))
      .map((each, index) => {
        return { id: each, display_order: index + 1 };
      });
    let filterCrewRememberNotInPlanTypeId = [];
    if (userRemember && userRemember.crews && userRemember.crews.length > 0) {
      userRemember.crews.forEach((each) => {
        if (!crewListById[each.id]) {
          filterCrewRememberNotInPlanTypeId.push(each);
        }
      });
    }
    let finalCrewToRemember = filterCrewRememberNotInPlanTypeId && filterCrewRememberNotInPlanTypeId.length > 0 ? filterCrewRememberNotInPlanTypeId.concat(finalSelectedCrewList) : finalSelectedCrewList;
    const addCrewListConfiguration = {
      farm_uuid: farmId,
      configuration: {
        remember: {
          ...userRemember,
          crews: finalCrewToRemember,
        },
      },
    };
    dispatch(saveUserConfiguration(addCrewListConfiguration));
    dispatch(getUserConfiguration({ farmId }));
    dispatch(setSelectedCrews([...selectedCrewIds]));
  };

  return (
    <Row className="crew-body-filteredList d-flex">
      <div className="title">Filtered : </div>
      {filteredCrewInfo.map((e) => (
        <div key={e.crew_uuid} className="crew-title d-flex">
          <p className="name">{e.crew_name} </p>
          <i className="fa fa-times-circle" aria-hidden="true" title="Unselect" onClick={() => handleCloseButton(e.crew_uuid)}></i>
        </div>
      ))}
    </Row>
  );
};

export default CrewFilteredList;
